import React, {useState} from "react";
import {Link, useLocation} from 'react-router-dom';
import {
    Box,
    Flex,
    // Heading,
    Stack,
    IconButton,
    Button,
    VStack,
    useBreakpointValue,
    Portal, CloseButton, Image
} from "@chakra-ui/react";
import {FiMenu, FiMoon} from "react-icons/fi";
import {PiSunLight} from "react-icons/pi";
import {
    DrawerRoot,
    DrawerTrigger,
    DrawerBackdrop,
    DrawerPositioner,
    DrawerContent,
    DrawerBody,
} from "@chakra-ui/react";
// import LogoDark from "../images/logo-dark.png";
// import LogoDark from "../images/logo-dark.svg";
import LogoDarkUpdated from "../images/logo-dark-updated.png";
import LogoLightUpdated from "../images/logo-light-updated.png";
// import LogoDarkMini from "../images/logo-dark-mini.png";
// import LogoLightMini from "../images/logo-light-mini.png";

function Header({isDark, toggleMode}) {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const isMobile = useBreakpointValue({base: true, md: false});
    const logoSrc = useBreakpointValue({
        // base: isDark ? LogoLightMini : LogoDarkMini,
        base: isDark ? LogoLightUpdated : LogoDarkUpdated,
    });

    const navLinks = [
        {label: "About", to: "/about"},
        {label: "Projects", to: "/projects"},
        {label: "Contact Me", to: "/contactme"},
    ];

    return (
        <Box
            pt={4}
            pb={4}
            position="sticky"
            top="0"
            zIndex="1000"
            bg={isDark ? "gray.900" : "white"}
            boxShadow="md"
            borderBottom="1px solid"
            borderColor={isDark ? "gray.700" : "gray.200"}
        >
            <Flex align="center" justify="space-between" px={6}>
                {/* Left: Logo */}
                <Box
                    display="flex"
                    alignItems="center"
                    height="60px" // keeps header height consistent
                >
                    <Image
                        src={logoSrc}
                        alt="Technically Tye Logo"
                        height="100%"       // fill header height
                        width="auto"        // preserve aspect ratio
                        maxW={{base: "140px", md: "220px"}} // 👈 controls width (adjust as needed)
                        draggable="false"
                        objectFit="contain" // ensure the logo isn’t cropped
                    />
                </Box>

                {/* Center: Navigation */}
                {!isMobile && (
                    <Flex flex={1} justify="center">
                        <Stack
                            direction="row"
                            spacing={4}
                            border="1px solid"
                            borderColor={isDark ? "gray.700" : "gray.200"}
                            borderRadius="md"
                            overflow="hidden"
                            p={2}
                        >
                            {navLinks.map((link, index) => {
                                const isActive = location.pathname === link.to;
                                return (
                                    <Box
                                        as={Link}
                                        to={link.to}
                                        key={link.label}
                                        px={3}
                                        display="flex"
                                        alignItems="center"
                                        borderRight={index < navLinks.length - 1 ? "1px solid" : "none"}
                                        borderColor={isDark ? "gray.700" : "gray.200"}
                                        fontWeight={isActive ? "bold" : "normal"}
                                        color={isActive ? (isDark ? "yellow.300" : "blue.600") : (isDark ? "white" : "black")}
                                        _hover={{
                                            color: isDark ? "yellow.300" : "blue.600",
                                        }}
                                    >
                                        {link.label}
                                    </Box>
                                );
                            })}
                        </Stack>
                    </Flex>
                )}

                {/* Right: Icons */}
                <Flex align="center" gap={3}>
                    <IconButton
                        onClick={toggleMode}
                        color={isDark ? "black" : "white"}
                        bg={isDark ? "whiteAlpha.800" : "gray.600"}
                        _hover={{color: isDark ? "yellow.500" : "blue.400"}}
                        aria-label="Toggle color mode"
                    >
                        {isDark ? <FiMoon/> : <PiSunLight/>}
                    </IconButton>

                    {isMobile && (
                        <DrawerRoot
                            size="xs"
                            open={isOpen}
                            onOpenChange={(open) => setIsOpen(open)}
                            onInteractOutside={() => setIsOpen(false)}
                        >
                            <DrawerTrigger asChild>
                                <Button
                                    variant="outline"
                                    size="sm"
                                    borderColor={isDark ? "white" : "black"}
                                    color={isDark ? "white" : "black"}
                                >
                                    <FiMenu/>
                                </Button>
                            </DrawerTrigger>
                            <Portal>
                                <DrawerBackdrop/>
                                <DrawerPositioner>
                                    <DrawerContent
                                        onInteractOutside={() => setIsOpen(false)}
                                        bg={isDark ? "gray.900" : "white"}
                                        color={isDark ? "white" : "black"}
                                    >
                                        <DrawerBody>
                                            <CloseButton
                                                size="md"
                                                position="absolute"
                                                top={2}
                                                right={2}
                                                onClick={() => setIsOpen(false)}
                                                color={isDark ? "white" : "black"}
                                            />
                                            <VStack spacing={4} mt={4}>
                                                {navLinks.map((link) => {
                                                    const isActive = location.pathname === link.to;
                                                    return (
                                                        <Box
                                                            as={Link}
                                                            to={link.to}
                                                            key={link.label}
                                                            fontSize="md"
                                                            fontWeight={isActive ? "bold" : "normal"}
                                                            borderBottom={isActive ? "2px solid" : "none"}
                                                            borderColor={isDark ? "yellow.300" : "blue.500"}
                                                            _hover={{
                                                                color: isDark ? "yellow.300" : "blue.600",
                                                            }}
                                                            onClick={() => setIsOpen(false)}
                                                        >
                                                            {link.label}
                                                        </Box>
                                                    );
                                                })}
                                            </VStack>
                                        </DrawerBody>
                                    </DrawerContent>
                                </DrawerPositioner>
                            </Portal>
                        </DrawerRoot>
                    )}
                </Flex>
            </Flex>
        </Box>
    );
}

export default Header;
